// import { useState } from "react";
// import { toast } from "react-toastify";
// import { addOrganizationApi } from "../../apis/organizationApi";

// export const useAddOrganization = () => {
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const addOrganization = async (orgData) => {
//     setLoading(true);
//     setError(null);

//     const toastId = toast.loading("Adding new organization...");

//     try {
//       const response = await addOrganizationApi(orgData);

//       toast.update(toastId, {
//         render: "Organization added successfully!",
//         type: "success",
//         isLoading: false,
//         autoClose: 3000,
//       });

//       return response;
//     } catch (err) {
//       const errorMessage =
//         err.response?.data?.data ||
//         err.data ||
//         "Failed to add organization. Please try again.";

//       toast.update(toastId, {
//         render: errorMessage,
//         type: "error",
//         isLoading: false,
//         autoClose: 5000,
//       });

//       setError(errorMessage);
//       throw err;
//     } finally {
//       setLoading(false);
//     }
//   };

//   return { addOrganization, loading, error };
// };
import { useState } from "react";
import { toast } from "react-toastify";
import { addOrganizationApi } from "../../apis/organizationApi";

export const useAddOrganization = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const extractError = (err) => {
    const res = err.response?.data;

    return {
      title: res?.message || "Organization Error",
      issue:
        res?.data ||
        err.message ||
        "Failed to add organization. Please try again.",
    };
  };

  const addOrganization = async (orgData) => {
    setLoading(true);
    setError(null);

    const toastId = toast.loading("Adding new organization...");

    try {
      const response = await addOrganizationApi(orgData);

      toast.update(toastId, {
        render: (
          <div>
            <strong>Organization Created</strong>
            <div>Organization added successfully!</div>
          </div>
        ),
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });

      return response.data; // assuming axios response
    } catch (err) {
      const { title, issue } = extractError(err);

      toast.update(toastId, {
        render: (
          <div>
            <strong>{title}</strong>
            <div>{issue}</div>
          </div>
        ),
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });

      setError({ title, issue });
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { addOrganization, loading, error };
};